/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const signImageUploadDataCollectionSchema = z.enum(['uploaded'])

export type SignImageUploadDataCollectionSchema = z.infer<typeof signImageUploadDataCollectionSchema>
